import { company } from '~/company/Company';

interface Params {
  path?: string;
  expires?: Date | number | string;
  'max-age'?: number;
}

export const setCookie = (
  name: string,
  value: string | number | boolean,
  params: Params = {},
) => {
  params = { path: '/', ...params };

  if (params.expires instanceof Date) {
    params.expires = params.expires.toUTCString();
  }

  const init = encodeURIComponent(name) + '=' + encodeURIComponent(value);

  document.cookie = Object.entries(params).reduce((acc, [key, value]) => {
    return `${acc}; ${key}=${value}`;
  }, init);
};

export const getCookie = (name: string) => {
  const result =
    document.cookie
      .split(';')
      .map((item) => item.trim().split('='))
      .find(([key]) => key === name) || [];

  return result && result[1]
    ? JSON.parse(decodeURIComponent(result[1]!))
    : undefined;
};

export const deleteCookie = (name: string) => {
  setCookie(name, '', { 'max-age': -1 });
};

export const clearAllCookie = () => {
  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  });
};

export const getCookieValue = (name: string) => {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    return match[2];
  }
};

export const COOKIE_CONSENT_KEY = 'cookie_consent';

export const getCookieConsent = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return getCookieValue(COOKIE_CONSENT_KEY);
};

export const isCookieConsentGranted = () => {
  if (import.meta.env.SSR) {
    return true;
  }

  if (!company.config.showCookieBanner) {
    return true;
  }

  return getCookieConsent() === 'accepted';
};

export const getCookieLang = () => {
  if (typeof window === 'undefined') {
    return company.config.lang;
  }

  const cookieLang = getCookieValue('lang');

  return cookieLang && company.config.langs?.includes(cookieLang)
    ? cookieLang
    : company.config.lang;
};
